var esprima = require("esprima");

class JSTextEditor {
  constructor(domNode, {
    body = ''
  }){
    this.domNode = domNode;
    this.editor = CodeMirror(this.domNode);
    this.editor.setValue(body);

    this.settledChangeListeners = [];
    this.changeListeners = [];

    this.previousTimeout = null;
    this.marks = [];
    this.editor.on('change', ()=>{
      let [valid, tokens] = parseFunctionBody(this.editor.getValue());
      this._syntaxHighlight(tokens);
      this.onChange(valid);

      if(this.previousTimeout){clearTimeout(this.previousTimeout);}
      this.previousTimeout = setTimeout(this.onSettledChange.bind(this, valid), 500);
    });
  }

  onSettledChange(valid){
    this.settledChangeListeners.forEach(listener=> listener(valid));
    this.previousTimeout = null;
  }

  onChange(valid){
    this.changeListeners.forEach(listener=> listener(valid));
  }

  _syntaxHighlight(tokens){
    tokens.forEach((token)=>{
      var doc = this.editor.doc;
      this.marks.push(doc.markText(
          doc.posFromIndex(token.range[0]),
          doc.posFromIndex(token.range[1]),
          {className: token.type}
      ));
    });
  }
}

var toExport = {
  JSTextEditor
};

if(typeof module !== "undefined" && typeof module.exports !== "undefined"){
  module.exports = toExport;
} else {
  Object.assign(window, toExport);
}

function parseFunctionBody(body){
  let wrappedBody = `(function(){${body}})`;
  let bodyStartIdx = 12,
      bodyEndIdx = wrappedBody.length - 3;

  let match;
  try {
    match = esprima.parse(wrappedBody, {range: true, tokens: true});
    let tokens = match.tokens.slice();
    tokens = tokens.filter(token=> (token.range[0] < bodyStartIdx) || (token.range[1] > bodyEndIdx));
    tokens.forEach(token=> {
      token.range[0] = token.range[0]-bodyStartIdx;
      token.range[1] = token.range[1]-bodyStartIdx;
    });
    return [true, tokens];
  } catch(e) {
    // console.error(e);
    return [false, esprima.tokenize(body, {range: true})];
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/jsTextEditor/jsTextEditor.js
 **/